module.exports = __webpack_public_path__ + "img/elementlengths_jak.0471aee6.png";